// Script de prueba para verificar el funcionamiento del flujo de pedidos
import { PedidosService } from '../services/pedidosService';

export const testPedidoCreation = async () => {
  console.log('=== PRUEBA DE CREACIÓN DE PEDIDOS ===');
  
  try {
    // Datos de prueba para un pedido
    const pedidoPrueba = {
      numeroDocumento: 'TEST-001',
      cliente: 'Juan Pérez',
      telefonoCliente: '1234567890',
      fechaCompra: '2025-10-28',
      fechaEntrega: '2025-10-29',
      importe: 1500.00,
      tipoPago: 'Efectivo',
      direccion: 'Calle Principal 123, Colonia Centro',
      estatus: 'en_preparacion',
      chofer: ''
    };
    
    console.log('1. Creando pedido de prueba...', pedidoPrueba);
    
    // Crear pedido
    const pedidoId = await PedidosService.crearPedido(pedidoPrueba);
    console.log('2. Pedido creado con ID:', pedidoId);
    
    // Obtener pedidos
    console.log('3. Obteniendo lista de pedidos...');
    const pedidos = await PedidosService.obtenerPedidos();
    console.log('4. Pedidos encontrados:', pedidos.length);
    console.log('5. Lista de pedidos:', pedidos);
    
    // Verificar que el pedido se guardó
    const pedidoEncontrado = pedidos.find(p => p.id === pedidoId);
    if (pedidoEncontrado) {
      console.log('✅ ÉXITO: El pedido se guardó correctamente');
      console.log('Datos del pedido guardado:', pedidoEncontrado);
    } else {
      console.log('❌ ERROR: El pedido no se encontró en la lista');
    }
    
    return { success: true, pedidoId, totalPedidos: pedidos.length };
    
  } catch (error) {
    console.error('❌ ERROR en la prueba:', error);
    return { success: false, error: error.message };
  }
};

// Función para limpiar datos de prueba
export const limpiarDatosPedidos = () => {
  try {
    localStorage.removeItem('pedidos_backup');
    console.log('Datos de pedidos de prueba limpiados');
  } catch (error) {
    console.error('Error al limpiar datos de pedidos de prueba:', error);
  }
};

// Función para verificar el estado actual
export const verificarEstadoPedidos = () => {
  try {
    const pedidos = PedidosService.obtenerDeLocalStorage();
    console.log('Estado actual de pedidos en localStorage:', pedidos.length, 'pedidos');
    console.log('Pedidos:', pedidos);
    return pedidos;
  } catch (error) {
    console.error('Error al verificar estado de pedidos:', error);
    return [];
  }
};







